/* eslint-disable no-nested-ternary */
import {
  CheckOutlined,
  DeleteOutlined,
  DownloadOutlined,
  FileProtectOutlined,
  InfoCircleOutlined,
  LeftOutlined,
  LoadingOutlined,
  MessageOutlined,
  RightOutlined,
  SearchOutlined,
  UploadOutlined
} from '@ant-design/icons';
import {
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  List,
  Modal,
  Result,
  Row,
  Space,
  Spin,
  Tooltip,
  Upload,
  message
} from 'antd';
import FileSaver from 'file-saver';
import React, { useContext, useEffect, useRef, useState } from 'react';
import Cards from 'react-credit-cards';
import 'react-credit-cards/es/styles-compiled.css';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { Document, Page, pdfjs } from 'react-pdf';
import { useHistory, useLocation } from 'react-router-dom';
import { SubSubtitleStart, Title } from '.';
import { USER_STATES } from '../constants';
import EmpresaContext from '../context/empresa-context';
import UserContext from '../context/user-context';
import PlanSelector from '../forms/personal/PlanSelector';
import { b64toBlob } from '../functions/images';
import {
  errorHandler,
  getDescripcionDocumento,
  heicAndheifConvert,
  parseCelular
} from '../utils';
import { instanceRef } from '../utils/axios';
import { formatoMonedaGenerico } from '../utils/converters';
import CustomCopyable from './CustomCopyable';
import Firma from './Firma';
import './FirmaView.css';
import { formatosArchivo } from './FirmaView.utils';
import LogoYTexto from './LogoYTexto';
import LogosEmpresaAseguradora from './LogosEmpresaAseguradora';
import ModalLoading from './ModalLoading';
import Pagos360Form from './Pagos360Form';
import ResponsiveContainer from './ResponsiveContainer';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const styles = {
  aceptoContainer: {
    textAlign: 'justify',
    paddingTop: 40,
    paddingBottom: 40
  },
  acepto: {
    width: '80%',
    fontSize: 12,
    textalign: 'justify',
    display: 'flex',
    alignItems: 'center'
  },
  list: {
    textAlign: 'left',
    maxWidth: 500,
    margin: 'auto',
    marginTop: 40
  },
  icon: { fontSize: 20 }
};

const scrollToRef = (ref) => {
  if (ref && ref.current) {
    const headerOffset = 64;
    const bodyRect = document.body.getBoundingClientRect().top;
    const elementRect = ref.current.getBoundingClientRect().top;
    const elementPosition = elementRect - bodyRect;
    const offsetPosition = elementPosition - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
};

const getTipo = (tipo) => {
  switch (tipo) {
    case 'VI':
      return 'visa';
    case 'VD':
      return 'visa';
    case 'MC':
      return 'mastercard';
    case 'AE':
      return 'amex';
    case 'MD':
      return 'mastercard';

    default:
      return tipo;
  }
};

function FirmaView(props) {
  const { match } = props;
  const { executeRecaptcha } = useGoogleReCaptcha();
  const history = useHistory();
  const [form] = Form.useForm();
  const myRef = useRef(null);
  const scrollTop = () => scrollToRef(myRef);
  const [loading, setLoading] = useState(true);
  const [loadingDocumentos, setLoadingDocumentos] = useState(true);
  const [loadingAutorizaciones, setLoadingAutorizaciones] = useState(true);
  const [solicitando, setSolicitando] = useState(false);
  const confirmado = false;
  const [solicitud, setSolicitud] = useState();
  const [catastro, setCatastro] = useState();
  const [tarjetas, setTarjetas] = useState([]);
  const [tarjetasVisible, setTarjetasVisible] = useState();
  const [eliminandoTarjeta, setEliminandoTarjeta] = useState(false);
  const [card, setCard] = useState();
  const [numPages, setNumPages] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [documentos, setDocumentos] = useState([]);
  const [dialogConfig, setDialogConfig] = useState(false);
  const { empresa, producto, updateProducto } = useContext(EmpresaContext);
  const [firma, setFirma] = useState();
  const [acepto, setAcepto] = useState(false);
  const [estado, setEstado] = useState();
  const [tokenInspeccion, setTokenInspeccion] = useState();
  const [controlesAutorizacion, setControlesAutorizacion] = useState(null);
  const [jsonPlan, setJsonPlan] = useState(null);
  const [firmaView, setFirmaView] = useState(false);
  const { user, userState } = useContext(UserContext);
  const [solicitudEnCurso, setSolicitudEnCurso] = useState(true);
  const [solicitudDigitalizada, setSolicitudDigitalizada] = useState(null);
  const [fileDownloaded, setFileDownloaded] = useState(false);
  const [tokenForRequests, setTokenForRequests] = useState(null);
  const [comprobanteIngresoList, setComprobanteIngresoList] = useState([]);
  const [facturaServiciosList, setFacturaServiciosList] = useState([]);
  const [fileUploadCounter, setFileUploadCounter] = useState(1);
  const [condicionesBase64, setCondicionesBase64] = useState(null);
  const [loadingCondiciones, setLoadingCondiciones] = useState(false);
  const [fileUploadCounterFactura, setFileUploadCounterFactura] = useState(1);
  const [pasoFirmar, setPasoFirmar] = useState(false);
  const location = useLocation();
  const [
    loadingSolicitudDigitalizada,
    setLoadingSolicitudDigitalizada
  ] = useState(false);

  const esClienteONoEstaLogueado =
    (user && user['cognito:groups'][0] === 'CLIENTE') ||
    (!user &&
      (userState === USER_STATES.loggingEnd ||
        userState === USER_STATES.notLogged));

  const textoAceptarGeneral = `
        Acepto las condiciones particulares de cobertura, la utilización de
        firma electrónica para la aprobación según "Ley 4017 de Validez Jurídica
        de Firma Electrónica", la utilización de los datos cargados en el
        formulario para la gestión de cobro y emisión de la póliza en formato
        digital.`;

  const textoRetraccion = `En caso de retracción, según lo establecido en la 'Ley 1334/98 de
        Defensa al Consumidor y del Usuario', no se aplicará ningún recargo por
        parte de la aseguradora si es realizado dentro del plazo de plazo de 7
        (siete) días contados desde la firma del contrato.`;

  const textoAceptarVehiculo =
    'Acepto las condiciones particulares de cobertura, inicio de cobertura (sujeta al pago y la inspección), la aprobación con firma electrónica según "Ley 4017 de Validez Jurídica de Firma Electrónica", la utilización de los datos cargados en este formulario para la gestión de cobro y la emisión de la póliza en forma digital.';
  const textoAceptarHogar =
    'Acepto las condiciones particulares de cobertura, inicio de cobertura (sujeta al pago), la aprobación con firma electrónica según "Ley 4017 de Validez Jurídica de Firma Electrónica", la utilización de los datos cargados en este formulario para la gestión de cobro y la emisión de la póliza en forma digital.';
  const textoAceptarPersonal =
    'Acepto las condiciones particulares de cobertura, inicio de cobertura (sujeta al pago), la aprobación con firma electrónica según "Ley 4017 de Validez Jurídica de Firma Electrónica", la utilización de los datos cargados en este formulario para la gestión de cobro y la emisión de la póliza en forma digital.';

  const getTextoAcepto = (p) => {
    switch (p) {
      case 1:
        return textoAceptarVehiculo;
      case 2:
        return textoAceptarPersonal;
      case 3:
        return textoAceptarPersonal;
      case 4:
        return textoAceptarHogar;
      case 5:
        return textoAceptarHogar;
      case 6:
        return textoAceptarHogar;
      default:
        return (
          <div>
            {' '}
            <div>{textoAceptarGeneral}</div>
            <div>{textoRetraccion}</div>
          </div>
        );
    }
  };

  const getMotivo = (reemplazo, motivo) => {
    if (reemplazo)
      return (
        <Tooltip
          title={`La cobertura mencionada fue reemplazada respecto a la cotización inicial ${motivo.toLowerCase()}`}
        >
          <InfoCircleOutlined
            style={{
              color: 'rgba(0,0,0,.45)'
            }}
          />
        </Tooltip>
      );
    return (
      <Tooltip title={motivo}>
        <InfoCircleOutlined
          style={{
            color: 'rgba(0,0,0,.45)'
          }}
        />
      </Tooltip>
    );
  };

  const textoAcepto = getTextoAcepto(7);

  const solicitar = async (values) => {
    if (solicitud?.metodoPago?.codigo === 'tarjeta' && !card) {
      message.warning('Debe seleccionar una tarjeta');
      return;
    }

    // Solicitud para empresa atlas, eliminar validacion obligatorio para los comprbantes
    // if (empresa.seprelad && solicitud?.metodoPago?.codigo === 'caja') {
    //   const validarComprobanteIngresoOk = validarComprobantes(
    //     comprobanteIngresoList
    //   );
    //   if (!validarComprobanteIngresoOk) {
    //     message.warning('Debe subir un Comprobante de Ingreso');
    //     return;
    //   }
    //   const validarFacturaServiciosOk = validarComprobantes(
    //     facturaServiciosList
    //   );
    //   if (!validarFacturaServiciosOk) {
    //     message.warning('Debe subir factura de servicios');
    //     return;
    //   }
    // }

    try {
      setLoading(true);
      setSolicitando(true);
      const { numeroCuenta } = values;
      const vencimientoTarjeta = card?.expiry;
      const numeroTarjeta = card?.number;
      const titularTarjeta = card?.name;
      const marcaTarjeta = card?.issuer ? card.issuer.toUpperCase() : '';
      const solicitudEnviar = {
        firma,
        solicituFirmaFisica: solicitudDigitalizada,
        referencia: values.referencia,
        datosPago: {
          numeroTarjeta,
          titularTarjeta,
          vencimientoTarjeta,
          marcaTarjeta,
          numeroCuenta
        },
        files: comprobanteIngresoList,
        facturas: facturaServiciosList
      };
      if (solicitud?.metodoPago?.codigo === 'tarjeta' && card) {
        solicitudEnviar.payment_method_client_id = card.id;
      }
      const reCaptchaToken = await executeRecaptcha('form/firmar');
      await instanceRef.instance.post(`form/firmar?token=${tokenForRequests}`, {
        ...solicitudEnviar,
        reCaptchaToken
      });

      // setSolicitud(response.data);
      await getSolicitud('actualizado');
      setSolicitando(false);
      setLoading(false);
      scrollTop();
    } catch (error) {
      setSolicitando(false);
      setLoading(false);
      message.error('No se pudo firmar la solicitud');
    }
  };

  const eliminarTarjeta = async (idCliente, idTarjeta) => {
    try {
      setEliminandoTarjeta(true);
      await instanceRef.instance.delete(
        `pagos/cliente/${idCliente}/tarjetas/${idTarjeta}`
      );
      message.info('Tarjeta eliminada correctamente');
      setLastCard(idCliente);
    } catch (error) {
      message.error('No se pudo eliminar la tarjeta');
    }
    setEliminandoTarjeta(false);
  };

  const getClienteTarjetas = (id) => {
    return instanceRef.instance.get(`pagos/cliente/${id}/tarjetas`);
  };

  const setLastCard = async (idCliente) => {
    const tarjetasResponse = await getClienteTarjetas(idCliente);
    setTarjetas(tarjetasResponse.data.data);
    if (
      !tarjetasResponse.data.data ||
      tarjetasResponse.data.data.length === 0
    ) {
      setCatastro(true);
      setTarjetasVisible(false);
    } else {
      const cardInfo = JSON.parse(
        tarjetasResponse.data.data[tarjetasResponse.data.data.length - 1]
          .card_info
      );
      setCard({
        id:
          tarjetasResponse.data.data[tarjetasResponse.data.data.length - 1].id,
        cvc: '',
        expiry: `${cardInfo.expiration_month}/${cardInfo.expiration_year}`,
        name: cardInfo.holder_name,
        number: cardInfo.last4,
        issuer: getTipo(cardInfo.brand)
      });
    }
  };

  const getSolicitud = async (origen) => {
    const fullPath = location.pathname;
    try {
      setLoading(true);
      const response = await instanceRef.instance.get(
        `solicitud/token/${props.match.params.token}?fullPath=${fullPath}`
      );
      if (response.data && response.data.data) {
        const isFirmarPublico = fullPath.includes('firmar-publico/');
        const isFirmarSms = fullPath.includes('firmar-sms/');
        if (isFirmarPublico || isFirmarSms) {
          setTokenForRequests(response.data.data.token);
        } else {
          setTokenForRequests(props.match.params.token);
        }
        if (origen === 'inicial' && response.data.data.estado !== 'PENDIENTE') {
          setSolicitudEnCurso(false);
          setLoading(false);
        }

        const idProducto = response.data.data.cotizacion?.id_producto;
        setSolicitud(response.data.data);
        if (origen === 'inicial') {
          setPasoFirmar(
            !(response.data.data?.metodoPago?.codigo === 'tarjeta')
          );
        }
        updateProducto(idProducto);
        setLoading(false);
        setEstado(response.data.data.estado);
        if (idProducto === 1) {
          const responseInspeccion = await instanceRef.instance.get(
            `inspeccion/solicitud/${tokenForRequests}`
          );
          if (responseInspeccion.data && responseInspeccion.data.data) {
            setTokenInspeccion(responseInspeccion.data.data.token);
          }
        }
        if (
          response.data.data.cotizacion?.persona?.id_cliente &&
          response.data.data.metodoPago?.codigo === 'tarjeta' &&
          response.data.data !== 'FINALIZADO'
        ) {
          await setLastCard(response.data.data.cotizacion.persona.id_cliente);
        }
      } else {
        message.error('No se ha encontrado la solicitud');
        setLoading(false);
      }
    } catch (error) {
      errorHandler(error, 'No se pudo obtener la solicitud');
      setLoading(false);
      if (error.response && error.response.status === 400) {
        history.push(
          `/regenerar-token?flujo=solicitud&tokenExpirado=${props.match.params.token}`
        );
      }
    }
  };

  const getDocumentos = async () => {
    try {
      setLoadingDocumentos(true);
      const formaPago = solicitud?.metodoPago?.codigo;
      const numeroCuenta = form.getFieldValue('numeroCuenta') || '';
      const response = await instanceRef.instance.post(
        `form/documentos?token=${tokenForRequests}`,
        {
          datosPago: {
            formaPago,
            numeroCuenta,
            titularTarjeta: card?.name,
            marcaTarjeta: card?.issuer,
            numeroTarjeta: card?.number,
            vencimientoTarjeta: card?.expiry
          },
          firma
        }
      );
      if (response.data.data && response.data.data.length === 0) {
        message.error('No se han encontrado los documentos');
        setLoadingDocumentos(false);
      } else {
        setDocumentos(
          response.data.data.map(({ filename, content }) => ({
            filename: getDescripcionDocumento(filename),
            content
          }))
        );
        setLoadingDocumentos(false);
      }
    } catch (error) {
      message.error('No se han encontrado los documentos');
      setLoadingDocumentos(false);
    }
  };

  const getCondicionesAseguradoraProducto = async () => {
    try {
      setLoadingCondiciones(true);
      const response = await instanceRef.instance.get(
        `/solicitud/file-condiciones/${props.match.params.token}`
      );
      setCondicionesBase64(response.data.fileBase64);
      setLoadingCondiciones(false);
    } catch (error) {
      // message.error('No se han encontrado las condiciones de producto');
      setLoadingCondiciones(false);
    }
  };

  const tieneControl = (controles) => {
    return (
      controles?.subcoberturasParaExcluir?.length > 0 ||
      controles?.controlDescuentosRecargos?.length > 0 ||
      controles?.controlFranquicias?.length > 0 ||
      controles?.accionesSubcoberturasParaExcluirRollback?.length > 0 ||
      controles?.recargosRollback?.length > 0 ||
      controles?.controlFranquiciasRollback?.length > 0 ||
      controles?.controlCostoAdicional?.length > 0 ||
      controles?.controlCostoMinimo?.length > 0 ||
      controles?.accionesControlCostoAdicionalRollback?.length > 0
    );
  };

  const getControlesAutorizacion = async () => {
    try {
      setLoadingAutorizaciones(true);
      const response = await instanceRef.instance.post(
        `autorizacion/controles?tipo=${'SOLICITUD'}&flujoId=${solicitud.id}`,
        solicitud?.json_plan
      );
      setControlesAutorizacion(response.data.data.controles);
      if (tieneControl(response.data.data.controles)) {
        setJsonPlan(response.data.data.controles.planActualizado);
        setFirmaView(false);
      } else {
        setFirmaView(true);
      }

      setLoadingAutorizaciones(false);
    } catch (error) {
      message.error('Controles de autorización');
      setLoadingAutorizaciones(false);
    }
  };

  function onDocumentLoadSuccess({ numPages: nextNumPages }) {
    setNumPages(nextNumPages);
  }

  const nextPage = () => {
    if (currentPage < numPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const previousPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const sendSms = async () => {
    try {
      const reCaptchaToken = await executeRecaptcha('sms/firmar');
      const data = {
        reCaptchaToken,
        persona: {
          celular: solicitud.cotizacion.persona.celular
        },
        token: solicitud.token,
        idEmpresa: solicitud.cotizacion.aseguradoraEmpresa.id_empresa
      };
      message.info(
        `${solicitud.cotizacion.persona.celular} recibirá un mensaje de ${
          solicitud.cotizacion.persona.via_contacto === 'whatsapp'
            ? 'Whatsapp'
            : 'texto'
        } para firmar el documento`
      );
      await instanceRef.instance.post(`sms/firmar`, data);
      history.push('/solicitudes');
    } catch (error2) {
      // error
    }
  };

  useEffect(() => {
    if (
      solicitud &&
      solicitud.estado === 'PENDIENTE' &&
      !solicitud.id_cotizacion_masiva_persona
    ) {
      getControlesAutorizacion();
      // TODO MASIVAS
    } else if (
      solicitud &&
      solicitud.estado === 'PENDIENTE' &&
      solicitud.id_cotizacion_masiva_persona
    ) {
      setFirmaView(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [solicitud]);

  useEffect(() => {
    getSolicitud('inicial');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const isPendiente = solicitud && solicitud.estado === 'PENDIENTE';

    if (isPendiente) {
      getDocumentos();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firma, solicitud, card]);

  useEffect(() => {
    getCondicionesAseguradoraProducto();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const downloadFile = (file, name) => {
    const blob = b64toBlob(file, 'application/pdf');
    FileSaver.saveAs(blob, name);
    setFileDownloaded(true);

    // const blobUrl = URL.createObjectURL(blob);
    // window.location = blobUrl;
  };
  const modalClassName = 'modal-header-document';

  function beforeUpload(file) {
    const isPermittedFormat =
      file.type === 'image/jpeg' ||
      file.type === 'image/heif' ||
      file.type === 'image/heic' ||
      file.type === 'image/png' ||
      file.type === 'application/pdf';

    if (!isPermittedFormat) {
      message.error('El formato del archivo no está permitido.');
      return false || Upload.LIST_IGNORE;
    }

    const isLt10M = file.size / 1024 / 1024 < 10;
    if (!isLt10M) {
      message.error('El tamaño del archivo debe ser inferior a 10MB.');
      return false || Upload.LIST_IGNORE;
    }
    return isPermittedFormat && isLt10M;
  }
  const toBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };
  const uploadFile = async (file, onSuccess, onError) => {
    try {
      setLoadingSolicitudDigitalizada(true);
      // El timeout es solo a efectos de que se visualize el spinner de carga
      setTimeout(async () => {
        try {
          const fileConverted = await heicAndheifConvert(file.file);
          const fileAsBase64 = await toBase64(fileConverted);
          const extension = fileConverted.type.split('/')[1];
          setSolicitudDigitalizada({
            content: fileAsBase64,
            filename: `SolicitudFirmada.${extension}`
          });
          onSuccess();
        } catch (error) {
          setSolicitudDigitalizada(null);
          errorHandler(error, 'Error al subir el archivo');
          onError();
        }
        setLoadingSolicitudDigitalizada(false);
      }, 750);
    } catch (error) {
      setSolicitudDigitalizada(null);
      errorHandler(error, 'Error al subir el archivo');
      onError();
      setLoadingSolicitudDigitalizada(false);
    }
  };

  const removeFileComprobanteIngresoList = (file) => {
    const updatedList = comprobanteIngresoList.filter(
      (item) => item.uid !== file.uid
    );
    setComprobanteIngresoList(updatedList);
  };

  const removeFileFacturaServicioList = (file) => {
    const updatedList = facturaServiciosList.filter(
      (item) => item.uid !== file.uid
    );
    setFacturaServiciosList(updatedList);
  };

  const uploadFileComprobanteIngreso = async (
    file,
    onSuccess,
    onError,
    fileUploadCounterParm,
    setFileUploadCounterParam
  ) => {
    try {
      setLoadingSolicitudDigitalizada(true);
      // El timeout es solo a efectos de que se visualize el spinner de carga
      setTimeout(async () => {
        try {
          const fileConverted = await heicAndheifConvert(file.file);
          const fileAsBase64 = await toBase64(fileConverted);
          const extension = fileConverted.type.split('/')[1];

          const newCounter = fileUploadCounterParm + 1;
          setFileUploadCounterParam(newCounter);
          const fileFinalName = `ComprobanteIngreso-${fileUploadCounterParm}.${extension}`;
          setComprobanteIngresoList([
            ...comprobanteIngresoList,
            {
              uid: file.file.uid,
              content: fileAsBase64,
              filename: fileFinalName
            }
          ]);
          onSuccess();
        } catch (error) {
          errorHandler(error, 'Error al subir el archivo');
          onError();
        }
      }, 750);
    } catch (error) {
      errorHandler(error, 'Error al subir el archivo');
      onError();
    }
  };

  const uploadFileFacturaServicios = async (
    file,
    onSuccess,
    onError,
    fileUploadCounterParm,
    setFileUploadCounterParam
  ) => {
    try {
      setLoadingSolicitudDigitalizada(true);
      // El timeout es solo a efectos de que se visualize el spinner de carga
      setTimeout(async () => {
        try {
          const fileConverted = await heicAndheifConvert(file.file);
          const fileAsBase64 = await toBase64(fileConverted);
          const extension = fileConverted.type.split('/')[1];

          const newCounter = fileUploadCounterParm + 1;
          setFileUploadCounterParam(newCounter);
          const fileFinalName = `FacturaServicios-${fileUploadCounterParm}.${extension}`;
          setFacturaServiciosList([
            ...facturaServiciosList,
            {
              uid: file.file.uid,
              content: fileAsBase64,
              filename: fileFinalName
            }
          ]);
          onSuccess();
        } catch (error) {
          errorHandler(error, 'Error al subir el archivo');
          onError();
        }
      }, 750);
    } catch (error) {
      errorHandler(error, 'Error al subir el archivo');
      onError();
    }
  };

  let IsSolicitarDisabled = true;

  if (solicitud && solicitud.cotizacion) {
    if (solicitud.cotizacion?.tipo_venta === 'presencial') {
      if (solicitudDigitalizada) {
        IsSolicitarDisabled = false;
      }
    } else if (acepto) {
      IsSolicitarDisabled = false;
    }
  }
  function getSolcitarSeguroButtonTitle() {
    if (
      solicitud.cotizacion?.tipo_venta === 'amedida' ||
      solicitud.cotizacion?.tipo_venta === 'estandar'
    ) {
      return 'Solicitar Seguro';
    }
    return 'Solicitar';
  }
  function getTooltipSolicitarTitle() {
    if (solicitud.cotizacion?.tipo_venta === 'presencial') {
      if (!solicitudDigitalizada) {
        return 'Debe subir el documento firmado';
      }
    }

    if (solicitud.cotizacion?.tipo_venta !== 'presencial') {
      if (!acepto) {
        return 'Debe aceptar las condiciones y firmar los documentos';
      }
    }

    return '';
  }

  return (
    <div>
      <LogosEmpresaAseguradora />
      <ResponsiveContainer>
        {firmaView && (
          <Card>
            <div ref={myRef} />
            {solicitud && estado === 'PENDIENTE' && (
              <>
                <Form
                  name="firma"
                  initialValues={{}}
                  onFinish={solicitar}
                  scrollToFirstError
                  form={form}
                  layout="vertical"
                  autoComplete="off"
                >
                  {['cadebito', 'ccdebito'].includes(
                    solicitud?.metodoPago?.codigo
                  ) ||
                    (solicitud?.metodoPago?.codigo === 'tarjeta' &&
                      !pasoFirmar && (
                        <Row
                          gutter={[16, 0]}
                          style={{
                            maxWidth: '1200px',
                            margin: 'auto',
                            textAlign: 'center'
                          }}
                          justify="center"
                        >
                          <Col xs={24} md={24} style={{ textAlign: 'center' }}>
                            <Title>
                              {confirmado && '¡Solicitud confirmada!'}
                              {!confirmado &&
                                `Confirme sus datos de ${solicitud?.metodoPago?.descripcion}`}
                            </Title>
                          </Col>
                          <Col xs={24} md={12} style={{ textAlign: 'center' }}>
                            {['cadebito', 'ccdebito'].includes(
                              solicitud?.metodoPago?.codigo
                            ) && (
                              <Form.Item
                                label="Número de cuenta"
                                name="numeroCuenta"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Campo requerido'
                                  }
                                ]}
                              >
                                <Input disabled={loading || solicitando} />
                              </Form.Item>
                            )}
                            {solicitud?.metodoPago?.codigo === 'tarjeta' &&
                              card &&
                              !tarjetasVisible &&
                              !catastro && (
                                <>
                                  <br />
                                  <Cards
                                    cvc={card.cvc}
                                    expiry={card.expiry}
                                    name={card.name}
                                    number={card.number}
                                    issuer={card.issuer}
                                    preview
                                    locale={{ valid: 'Válido hasta' }}
                                    placeholders={{ name: '' }}
                                  />
                                  <br />
                                  <Button
                                    type="link"
                                    onClick={() => {
                                      setTarjetasVisible(true);
                                      setCard();
                                    }}
                                  >
                                    Usar otra
                                  </Button>
                                  <br />
                                  <br />
                                  <Button
                                    // type="link"
                                    onClick={() => {
                                      setPasoFirmar(true);
                                    }}
                                  >
                                    Firmar documentos
                                  </Button>
                                </>
                              )}
                            {solicitud?.metodoPago?.codigo === 'tarjeta' &&
                              catastro && (
                                <>
                                  <Title>Catastro de tarjeta</Title>
                                  <div align="middle">
                                    <div style={{ maxWidth: 500 }}>
                                      <Pagos360Form
                                        config={{
                                          clientId:
                                            solicitud.cotizacion.persona
                                              .id_cliente
                                        }}
                                        type="bancard"
                                        onSuccess={() => {
                                          message.success(
                                            'Tarjeta catastrada correctamente'
                                          );
                                          setCatastro(false);
                                          setLastCard(
                                            solicitud.cotizacion.persona
                                              .id_cliente
                                          );
                                        }}
                                        onError={(data) => {
                                          if (
                                            data.error &&
                                            data.error.message &&
                                            data.error.message.code === 5001
                                          ) {
                                            message.error(
                                              `Error al catastrar tarjeta: Verificar documento`
                                            );
                                          } else {
                                            message.error(
                                              `Error al catastrar tarjeta: ${JSON.stringify(
                                                data
                                              )}`
                                            );
                                          }
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <br />
                                  {tarjetas.length > 0 && (
                                    <Button
                                      onClick={() => {
                                        setCatastro(false);
                                        setTarjetasVisible(true);
                                      }}
                                    >
                                      Usar existente
                                    </Button>
                                  )}
                                </>
                              )}
                          </Col>
                        </Row>
                      ))}
                  {tarjetasVisible && (
                    <div align="middle">
                      <Card
                        title="Seleccione su tarjeta"
                        style={{
                          textAlign: 'left',
                          maxWidth: 600,
                          boxShadow: 'none'
                        }}
                        bordered={false}
                        actions={[
                          <Button
                            onClick={() => {
                              setCatastro(true);
                              setTarjetasVisible(false);
                            }}
                          >
                            Agregar Nueva
                          </Button>
                        ]}
                        onCancel={() => setTarjetasVisible(false)}
                      >
                        <List
                          size="small"
                          itemLayout="vertical"
                          dataSource={tarjetas.map((item) => {
                            const cardInfo = JSON.parse(item.card_info);
                            const innerCard = {
                              id: item.id,
                              cvc: '123',
                              expiry: `${cardInfo.expiration_month}/${cardInfo.expiration_year}`,
                              name: cardInfo.holder_name,
                              number: cardInfo.last4,
                              issuer: getTipo(cardInfo.brand),
                              last4: cardInfo.last4
                            };
                            return innerCard;
                          })}
                          renderItem={(item) => (
                            <Card
                              actions={[
                                <Button
                                  type="link"
                                  icon={<CheckOutlined />}
                                  disabled={eliminandoTarjeta}
                                  onClick={() => {
                                    setCard(item);
                                    setTarjetasVisible(false);
                                    setCatastro(false);
                                  }}
                                />,
                                <Button
                                  type="text"
                                  icon={<DeleteOutlined />}
                                  loading={eliminandoTarjeta}
                                  onClick={() =>
                                    eliminarTarjeta(
                                      solicitud.cotizacion.persona.id_cliente,
                                      item.id
                                    )
                                  }
                                />
                              ]}
                              style={{ marginTop: 20 }}
                              size="small"
                            >
                              <List.Item
                                extra={
                                  <div className="small">
                                    <Cards
                                      cvc={item.cvc}
                                      expiry={item.expiry}
                                      name={item.name}
                                      number={item.number}
                                      issuer={item.issuer}
                                      preview
                                      locale={{ valid: 'Válido hasta' }}
                                      placeholders={{ name: '' }}
                                    />
                                  </div>
                                }
                              >
                                <List.Item.Meta
                                  title={
                                    <span
                                      style={{ textTransform: 'uppercase' }}
                                    >
                                      {`${item.issuer}`}
                                    </span>
                                  }
                                  description={`${item.last4}`}
                                />
                              </List.Item>
                            </Card>
                          )}
                        />
                      </Card>
                    </div>
                  )}
                  <Modal
                    bodyStyle={{
                      padding: 0,
                      paddingBottom: 20
                    }}
                    width={750}
                    className={modalClassName}
                    title={[
                      <div key="descargar">
                        {dialogConfig.title}
                        <span className="span-download-button">
                          <Button
                            type="dashed"
                            size="large"
                            icon={<DownloadOutlined />}
                            onClick={() =>
                              downloadFile(
                                dialogConfig.content,
                                dialogConfig.title
                              )
                            }
                          >
                            Descargar
                          </Button>
                        </span>
                      </div>
                    ]}
                    centered
                    open={dialogConfig.open}
                    afterClose={() =>
                      setDialogConfig({
                        open: false,
                        content: undefined,
                        title: ''
                      })
                    }
                    onCancel={() =>
                      setDialogConfig({
                        open: false,
                        content: undefined,
                        title: ''
                      })
                    }
                    footer={null}
                  >
                    <div>
                      {dialogConfig.content && (
                        <Document
                          onLoadSuccess={onDocumentLoadSuccess}
                          loading={<Spin />}
                          file={`data:application/pdf;base64,${
                            dialogConfig.condiciones
                              ? condicionesBase64
                              : dialogConfig.content
                          }`}
                          style={{ height: '100%' }}
                        >
                          <Page
                            key={`page_${currentPage + 1}`}
                            pageNumber={currentPage + 1}
                            width="750"
                          />
                          <div style={{ textAlign: 'center' }}>
                            <Button
                              type="link"
                              onClick={() => previousPage()}
                              disabled={currentPage === 0}
                            >
                              <LeftOutlined />
                              Anterior
                            </Button>
                            Pág. {currentPage + 1} de {numPages}
                            <Button
                              type="link"
                              onClick={() => nextPage()}
                              disabled={currentPage + 1 === numPages}
                            >
                              Siguiente
                              <RightOutlined />
                            </Button>
                          </div>
                        </Document>
                      )}
                    </div>
                  </Modal>
                  {pasoFirmar && (
                    <>
                      <Title>
                        {(user && user['cognito:groups'][0] === 'CLIENTE') ||
                          (!user && <>Firma de Documentos</>)}
                        {user &&
                          user['cognito:groups'][0] !== 'CLIENTE' &&
                          solicitud.cotizacion?.tipo_venta === 'telefonica' && (
                            <>Aprobar Documentos</>
                          )}
                        {user &&
                          user['cognito:groups'][0] !== 'CLIENTE' &&
                          solicitud.cotizacion?.tipo_venta !== 'telefonica' && (
                            <>Firma de Documentos</>
                          )}
                      </Title>
                      <List
                        footer={
                          <div>
                            {solicitud.cotizacion?.tipo_venta !==
                              'presencial' && (
                              <Row justify="space-between" align="middle">
                                <Col>
                                  <Firma
                                    error={!firma}
                                    text={
                                      !firma
                                        ? 'Firmar documentos'
                                        : 'Documentos firmados'
                                    }
                                    disabled={confirmado}
                                    onSuccess={(value) =>
                                      setFirma(value.split(',')[1])
                                    }
                                  />
                                </Col>
                                {user &&
                                  user['cognito:groups'][0] !== 'CLIENTE' && (
                                    <Col>
                                      <Row>
                                        {solicitud.cotizacion?.persona
                                          ?.celular &&
                                          (empresa.tiene_sms ||
                                            empresa.tiene_whatsapp) && (
                                            <Col>
                                              <Tooltip
                                                title={`Enviar enlace para firmar a ${parseCelular(
                                                  solicitud.cotizacion.persona
                                                    .celular
                                                )}`}
                                              >
                                                <Button
                                                  type="text"
                                                  onClick={() => {
                                                    sendSms();
                                                  }}
                                                  icon={<MessageOutlined />}
                                                >
                                                  {empresa.tiene_whatsapp &&
                                                  solicitud.cotizacion.persona
                                                    .via_contacto === 'whatsapp'
                                                    ? 'Enviar por Whatsapp'
                                                    : 'Enviar por SMS'}
                                                </Button>
                                              </Tooltip>
                                            </Col>
                                          )}

                                        <Col>
                                          <Button
                                            type="text"
                                            icon={
                                              <CustomCopyable
                                                copyable={{
                                                  text: `${window.location.origin}/firmar/${match.params.token}`,
                                                  tooltips: [
                                                    'Copiar enlace para firmar',
                                                    'Copiado'
                                                  ]
                                                }}
                                              />
                                            }
                                            size="middle"
                                          />
                                        </Col>
                                      </Row>
                                    </Col>
                                  )}
                              </Row>
                            )}
                            {solicitud.cotizacion?.tipo_venta ===
                              'presencial' && (
                              <Row justify="space-between" align="middle">
                                <Col>
                                  <Upload
                                    style={{ width: 'auto !important' }}
                                    name="SolicitudFirmada"
                                    accept={formatosArchivo}
                                    listType="text"
                                    onRemove={() => {
                                      setSolicitudDigitalizada(null);
                                    }}
                                    customRequest={(file) =>
                                      uploadFile(
                                        file,
                                        file.onSuccess,
                                        file.onError
                                      )
                                    }
                                    beforeUpload={(file) => beforeUpload(file)}
                                    maxCount={1}
                                    disabled={!fileDownloaded}
                                  >
                                    <Tooltip
                                      title={
                                        !fileDownloaded
                                          ? 'Descargue primeramente el formulario a adjuntar'
                                          : ''
                                      }
                                    >
                                      <Button
                                        icon={<UploadOutlined />}
                                        disabled={!fileDownloaded}
                                      >
                                        {loadingSolicitudDigitalizada ? (
                                          <LoadingOutlined />
                                        ) : (
                                          'Adjuntar solicitud firmada'
                                        )}
                                      </Button>
                                    </Tooltip>
                                  </Upload>
                                </Col>
                              </Row>
                            )}
                          </div>
                        }
                        loading={loadingDocumentos}
                        dataSource={documentos}
                        size="large"
                        bordered
                        style={styles.list}
                        renderItem={(item) => (
                          <List.Item
                            actions={[
                              <Tooltip title="Ver">
                                <Button
                                  type="text"
                                  onClick={() => {
                                    setCurrentPage(0);
                                    setDialogConfig({
                                      open: true,
                                      content: item.content,
                                      title: item.filename,
                                      condiciones: false
                                    });
                                  }}
                                  icon={<SearchOutlined />}
                                  size="middle"
                                />
                              </Tooltip>,
                              <Tooltip title="Descargar">
                                <Button
                                  type="text"
                                  icon={<DownloadOutlined />}
                                  onClick={() =>
                                    downloadFile(item.content, item.filename)
                                  }
                                  size="middle"
                                />
                              </Tooltip>,

                              <Tooltip
                                title={
                                  loadingCondiciones
                                    ? 'Cargando Condiciones del Producto'
                                    : 'Condiciones del Producto'
                                }
                              >
                                <Button
                                  type="text"
                                  style={{
                                    visibility:
                                      item.filename.includes('Formulario') ||
                                      documentos.length === 1
                                        ? ''
                                        : 'hidden'
                                  }}
                                  disabled={!condicionesBase64}
                                  loading={loadingCondiciones}
                                  icon={<FileProtectOutlined />}
                                  onClick={() => {
                                    setCurrentPage(0);
                                    setDialogConfig({
                                      open: true,
                                      content: condicionesBase64,
                                      title: 'Condiciones de Producto',
                                      condiciones: true
                                    });
                                  }}
                                  size="middle"
                                />
                              </Tooltip>
                            ]}
                          >
                            <List.Item.Meta title={item.filename} />
                          </List.Item>
                        )}
                      />

                      <br />
                      {solicitud &&
                        empresa?.seprelad &&
                        solicitud?.metodoPago?.codigo === 'caja' && (
                          <>
                            <Row style={styles.list}>
                              <Col xs={24} md={18}>
                                <Upload
                                  style={{ width: 'auto !important' }}
                                  name="comprobanteIngreso"
                                  accept={formatosArchivo}
                                  listType="text"
                                  onRemove={(file) =>
                                    removeFileComprobanteIngresoList(file)
                                  }
                                  customRequest={(file) =>
                                    uploadFileComprobanteIngreso(
                                      file,
                                      file.onSuccess,
                                      file.onError,
                                      fileUploadCounter,
                                      setFileUploadCounter
                                    )
                                  }
                                  beforeUpload={(file) => beforeUpload(file)}
                                >
                                  <Button icon={<UploadOutlined />}>
                                    Comprobante de Ingreso
                                  </Button>
                                </Upload>
                              </Col>
                            </Row>
                            <Row style={styles.list}>
                              <Col xs={24} md={18}>
                                <Upload
                                  style={{ width: 'auto !important' }}
                                  name="facturaServicios"
                                  accept={formatosArchivo}
                                  listType="text"
                                  onRemove={(file) =>
                                    removeFileFacturaServicioList(file)
                                  }
                                  customRequest={(file) =>
                                    uploadFileFacturaServicios(
                                      file,
                                      file.onSuccess,
                                      file.onError,
                                      fileUploadCounterFactura,
                                      setFileUploadCounterFactura
                                    )
                                  }
                                  beforeUpload={(file) => beforeUpload(file)}
                                >
                                  <Button icon={<UploadOutlined />}>
                                    Factura de Servicios (ANDE, ESSAP, otros)
                                  </Button>
                                </Upload>
                              </Col>
                            </Row>
                          </>
                        )}
                      <br />
                      {solicitud &&
                        solicitud.cotizacion?.tipo_venta === 'telefonica' &&
                        user &&
                        user['cognito:groups'][0] !== 'CLIENTE' && (
                          <Row
                            gutter={[16, 0]}
                            justify="center"
                            align="middle"
                            style={styles.aceptoContainer}
                          >
                            <Col xs={24} md={18}>
                              <Form.Item
                                label="Referencia"
                                name="referencia"
                                rules={[
                                  { required: true, message: 'Requerido' }
                                ]}
                              >
                                <Input />
                              </Form.Item>
                            </Col>
                            <Col xs={24} md={18}>
                              <Space>
                                {tieneControl(controlesAutorizacion) && (
                                  <Button
                                    key="console"
                                    onClick={() => setFirmaView(!firmaView)}
                                  >
                                    Atrás
                                  </Button>
                                )}
                                <Button
                                  type="primary"
                                  htmlType="submit"
                                  loading={loading || solicitando}
                                >
                                  Aprobar
                                </Button>
                              </Space>
                            </Col>
                          </Row>
                        )}
                      {((solicitud &&
                        solicitud.cotizacion?.tipo_venta === 'telefonica' &&
                        esClienteONoEstaLogueado) ||
                        (solicitud &&
                          solicitud.cotizacion?.tipo_venta !== 'telefonica')) &&
                        solicitud && (
                          <>
                            {solicitud.cotizacion?.tipo_venta !==
                              'presencial' && (
                              <Row
                                gutter={[16, 0]}
                                justify="center"
                                align="middle"
                                style={styles.aceptoContainer}
                              >
                                <Col
                                  xs={24}
                                  md={18}
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'center'
                                  }}
                                >
                                  <Checkbox
                                    checked={acepto}
                                    disabled={confirmado}
                                    onChange={(e) =>
                                      setAcepto(e.target.checked)
                                    }
                                    style={styles.acepto}
                                  >
                                    {textoAcepto}
                                  </Checkbox>
                                </Col>
                              </Row>
                            )}

                            <Space>
                              {tieneControl(controlesAutorizacion) && (
                                <Button
                                  key="console"
                                  onClick={() => setFirmaView(!firmaView)}
                                >
                                  Atrás
                                </Button>
                              )}
                              {solicitud?.metodoPago?.codigo === 'tarjeta' && (
                                <Button
                                  key="console"
                                  onClick={() => setPasoFirmar(false)}
                                >
                                  Cambiar tarjeta
                                </Button>
                              )}
                              <Tooltip title={getTooltipSolicitarTitle()}>
                                <Button
                                  type="primary"
                                  htmlType="submit"
                                  disabled={IsSolicitarDisabled}
                                  loading={
                                    loading || solicitando || loadingDocumentos
                                  }
                                >
                                  {getSolcitarSeguroButtonTitle()}
                                </Button>
                              </Tooltip>
                            </Space>
                          </>
                        )}
                    </>
                  )}
                </Form>
              </>
            )}
            {solicitud &&
              solicitud.autorizacionFlujo.length === 0 &&
              (estado === 'VERIFICAR' ||
                estado === 'PROCESANDO' ||
                estado === 'FINALIZADO' ||
                estado === 'PENDIENTE_AUTORIZACION') && (
                <div style={styles.content}>
                  <Result
                    status="success"
                    title={
                      producto === 1
                        ? '¡La solicitud fue generada con éxito!'
                        : '¡La solicitud fue enviada exitosamente!'
                    }
                    subTitle={
                      producto === 1
                        ? 'Se requiere la inspección para finalizar el proceso de contratación'
                        : 'Se le estará notificando cuando continúe el proceso de emisión de póliza'
                    }
                    extra={[
                      <Button
                        type="primary"
                        key="console"
                        loading={!tokenInspeccion && producto === 1}
                        onClick={() => {
                          if (producto === 1) {
                            window.location.href = `/inspecciones/form/${tokenInspeccion}`;
                          } else {
                            window.location.href = `/solicitudes/${solicitud.token}`;
                          }
                        }}
                      >
                        {producto === 1
                          ? `Realizar la inspección ahora`
                          : `Ver solicitud`}
                      </Button>,
                      producto === 1 && user && (
                        <>
                          {!tokenInspeccion ? (
                            <LoadingOutlined />
                          ) : (
                            <Button type="text" key="copiar" size="middle">
                              <CustomCopyable
                                copyable={{
                                  text: `${window.location.origin}/inspecciones/form/${tokenInspeccion}`,
                                  tooltips: [
                                    'Copiar enlace para inspección',
                                    'Copiado'
                                  ]
                                }}
                              >
                                Copiar enlace{' '}
                              </CustomCopyable>
                            </Button>
                          )}
                        </>
                      )
                    ]}
                  />
                </div>
              )}
            {solicitud &&
              solicitud.autorizacionFlujo.length > 0 &&
              (estado === 'VERIFICAR' ||
                estado === 'PROCESANDO' ||
                estado === 'FINALIZADO' ||
                estado === 'PENDIENTE_AUTORIZACION') && (
                <div style={styles.content}>
                  <Result
                    title="Solicitud sujeta a autorización del área técnica"
                    subTitle="Una vez aprobada la solicitud, será notificado de la emisión de la póliza y a partir de ese momento entrará en vigencia la cobertura."
                    extra={[
                      <Button
                        type="primary"
                        key="console"
                        onClick={() => {
                          window.location.href = `/solicitudes/${solicitud.token}`;
                        }}
                      >
                        Ver solicitud
                      </Button>
                    ]}
                  />
                </div>
              )}
          </Card>
        )}
        {!firmaView && controlesAutorizacion && (
          <Card>
            <Spin spinning={loadingAutorizaciones} size="large">
              {tieneControl(controlesAutorizacion) && (
                <>
                  <Title>Cambios aplicados a la cotización</Title>
                  <table style={{ margin: 'auto' }}>
                    <tbody>
                      <tr>
                        <td
                          style={{
                            textAlign: 'left',
                            display: 'flex',
                            alignItems: 'center'
                          }}
                        >
                          <LogoYTexto
                            logo={`/images/aseguradoras/${solicitud?.cotizacion.aseguradoraEmpresa.aseguradora.codigo}.png`}
                            texto={
                              solicitud?.cotizacion.aseguradoraEmpresa
                                .aseguradora.nombre
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>
                          {jsonPlan?.id && (
                            <div style={{ overflowX: 'auto' }}>
                              <PlanSelector
                                planes={[jsonPlan]}
                                hover={false}
                                mostrarTipo
                                moneda={solicitud?.moneda}
                                opcionesDePago={{
                                  numeroCuotas:
                                    solicitud?.json_plan.numeroCuotas
                                }}
                                infoMoneda
                                readonly
                                controlFranquicias={
                                  controlesAutorizacion.controlFranquicias
                                }
                              />
                            </div>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <br />
                          <SubSubtitleStart
                            style={{
                              paddingTop: 20
                            }}
                          >
                            Se han aplicado los siguientes cambios al plan:{' '}
                          </SubSubtitleStart>

                          <>
                            {!!controlesAutorizacion.subcoberturasParaExcluir
                              .length && (
                              <>
                                {!!controlesAutorizacion.subcoberturasParaExcluir.filter(
                                  (item) => !item.controlProductoCobertura.subcR
                                ).length && (
                                  <List
                                    size="small"
                                    style={{ textAlign: 'left' }}
                                    dataSource={controlesAutorizacion.subcoberturasParaExcluir.filter(
                                      (item) =>
                                        !item.controlProductoCobertura.subcR
                                    )}
                                    renderItem={(item) => (
                                      <List.Item>
                                        -{' La cobertura '}
                                        <strong>
                                          {
                                            item.controlProductoCobertura
                                              .subcobertura?.cobertura
                                              .descripcion
                                          }
                                        </strong>
                                        {' fue excluída.'}
                                        {getMotivo(true, item.motivo)}
                                      </List.Item>
                                    )}
                                  />
                                )}
                                {!!controlesAutorizacion.subcoberturasParaExcluir.filter(
                                  (item) => item.controlProductoCobertura.subcR
                                ).length && (
                                  <List
                                    size="small"
                                    style={{ textAlign: 'left' }}
                                    dataSource={controlesAutorizacion.subcoberturasParaExcluir.filter(
                                      (item) =>
                                        item.controlProductoCobertura.subcR
                                    )}
                                    renderItem={(item) => (
                                      <List.Item style={{ textAlign: 'left' }}>
                                        -{' La cobertura '}
                                        <strong>
                                          {
                                            item.controlProductoCobertura
                                              .subcobertura?.cobertura
                                              .descripcion
                                          }
                                        </strong>
                                        {' fue reemplazada por '}{' '}
                                        <strong>
                                          {
                                            item.controlProductoCobertura.subcR
                                              ?.cobertura.descripcion
                                          }
                                        </strong>{' '}
                                        {getMotivo(true, item.motivo)}
                                      </List.Item>
                                    )}
                                  />
                                )}
                              </>
                            )}
                            {!!controlesAutorizacion.controlDescuentosRecargos
                              .length && (
                              <List
                                size="small"
                                style={{ textAlign: 'left' }}
                                dataSource={
                                  controlesAutorizacion.controlDescuentosRecargos
                                }
                                renderItem={(item) => (
                                  <List.Item>
                                    -
                                    {item.descuentosRecargos > 0
                                      ? ' Se aplicó un recargo de: '
                                      : ' Se aplicó un descuento de: '}
                                    <strong>
                                      {item.descuentosRecargos}
                                      {'%'}
                                    </strong>
                                    .{getMotivo(false, item.motivo)}
                                  </List.Item>
                                )}
                              />
                            )}
                            {!!controlesAutorizacion.controlCostoAdicional
                              .length && (
                              <List
                                size="small"
                                style={{ textAlign: 'left' }}
                                dataSource={
                                  controlesAutorizacion.controlCostoAdicional
                                }
                                renderItem={(item) => (
                                  <List.Item>
                                    - Se aplicó un Costo Adicional por ocupante
                                    de:
                                    <strong>
                                      {formatoMonedaGenerico(
                                        item.moneda,
                                        item.costoAdicional
                                      )}
                                    </strong>
                                    .{getMotivo(false, item.motivo)}
                                  </List.Item>
                                )}
                              />
                            )}
                            {!!controlesAutorizacion.controlCostoMinimo
                              .length && (
                              <List
                                size="small"
                                style={{ textAlign: 'left' }}
                                dataSource={
                                  controlesAutorizacion.controlCostoMinimo
                                }
                                renderItem={(item) => (
                                  <List.Item>
                                    Costo Mínimo aplicado:
                                    <strong>
                                      {formatoMonedaGenerico(
                                        item.moneda,
                                        item.costoMinimo
                                      )}
                                    </strong>
                                    .{getMotivo(false, item.motivo)}
                                  </List.Item>
                                )}
                              />
                            )}
                            {!!controlesAutorizacion.controlFranquicias[0]
                              ?.franquicias && (
                              <List
                                size="small"
                                style={{ textAlign: 'left' }}
                                dataSource={
                                  controlesAutorizacion.controlFranquicias[0]
                                    .franquicias
                                }
                                renderItem={(item) => (
                                  <List.Item>
                                    - Inclusión de Franquicia General{' '}
                                    <strong>{item.descripcion}</strong>{' '}
                                    {getMotivo(
                                      false,
                                      controlesAutorizacion
                                        .controlFranquicias[0].motivo
                                    )}
                                  </List.Item>
                                )}
                              />
                            )}
                            {!!controlesAutorizacion
                              .controlFranquiciasRollback[0] && (
                              <List
                                size="small"
                                style={{ textAlign: 'left' }}
                                dataSource={
                                  controlesAutorizacion
                                    .controlFranquiciasRollback[0].franquicias
                                }
                                renderItem={(item) => (
                                  <List.Item>
                                    Exclusión de Franquicia:{' '}
                                    <strong>{item.descripcion}</strong>{' '}
                                    {getMotivo(
                                      false,
                                      controlesAutorizacion
                                        .controlFranquicias[0].motivo
                                    )}
                                  </List.Item>
                                )}
                              />
                            )}
                            {!!controlesAutorizacion
                              .accionesSubcoberturasParaExcluirRollback
                              .length && (
                              <>
                                {!!controlesAutorizacion.accionesSubcoberturasParaExcluirRollback.filter(
                                  (item) => item.tipo === 'EXCLUSION_COBERTURA'
                                ).length && (
                                  <List
                                    size="small"
                                    style={{ textAlign: 'left' }}
                                    dataSource={controlesAutorizacion.accionesSubcoberturasParaExcluirRollback.filter(
                                      (item) =>
                                        item.tipo === 'EXCLUSION_COBERTURA'
                                    )}
                                    renderItem={(item) => (
                                      <List.Item>
                                        -{' La cobertura '}
                                        <strong>
                                          {
                                            item.controlProductoCobertura
                                              .subcobertura.cobertura
                                              .descripcion
                                          }
                                        </strong>
                                        {' fue incluida.'}
                                        {getMotivo(false, item.motivo)}
                                      </List.Item>
                                    )}
                                  />
                                )}
                                {!!controlesAutorizacion.accionesSubcoberturasParaExcluirRollback.filter(
                                  (item) => item.tipo === 'REEMPLAZO_COBERTURA'
                                ).length && (
                                  <List
                                    size="small"
                                    style={{ textAlign: 'left' }}
                                    dataSource={controlesAutorizacion.accionesSubcoberturasParaExcluirRollback.filter(
                                      (item) =>
                                        item.tipo === 'REEMPLAZO_COBERTURA'
                                    )}
                                    renderItem={(item) => (
                                      <List.Item style={{ textAlign: 'left' }}>
                                        -{' La cobertura '}
                                        <strong>
                                          {
                                            item.controlProductoCobertura.subcR
                                              ?.cobertura.descripcion
                                          }
                                        </strong>
                                        {' fue reemplazada por '}{' '}
                                        <strong>
                                          {
                                            item.controlProductoCobertura
                                              .subcobertura?.cobertura
                                              .descripcion
                                          }
                                        </strong>{' '}
                                        {getMotivo(true, item.motivo)}
                                      </List.Item>
                                    )}
                                  />
                                )}
                              </>
                            )}
                            {!!controlesAutorizacion.recargosRollback
                              .length && (
                              <List
                                size="small"
                                style={{ textAlign: 'left' }}
                                dataSource={
                                  controlesAutorizacion.recargosRollback
                                }
                                renderItem={(item) => (
                                  <List.Item>
                                    - Se aplicó un descuento de:
                                    <strong>
                                      {item.descuentosRecargos}
                                      {'%'}
                                    </strong>
                                    .{getMotivo(false, item.motivo)}
                                  </List.Item>
                                )}
                              />
                            )}
                            {!!controlesAutorizacion
                              .accionesControlCostoAdicionalRollback.length && (
                              <List
                                size="small"
                                style={{ textAlign: 'left' }}
                                dataSource={
                                  controlesAutorizacion.accionesControlCostoAdicionalRollback
                                }
                                renderItem={(item) => (
                                  <List.Item>
                                    - Se quitó costo adicional por ocupante de:
                                    <strong>
                                      <strong>
                                        {formatoMonedaGenerico(
                                          item.moneda,
                                          item.costoAdicional
                                        )}
                                      </strong>{' '}
                                    </strong>
                                    .{getMotivo(false, item.motivo)}
                                  </List.Item>
                                )}
                              />
                            )}
                          </>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <br />
                  <Button
                    type="primary"
                    key="console"
                    onClick={() => setFirmaView(!firmaView)}
                  >
                    Siguiente
                  </Button>{' '}
                </>
              )}
            </Spin>
          </Card>
        )}
        {solicitudEnCurso === false && (
          <Result
            title="La solicitud ya fue firmada."
            extra={[
              <Button
                type="primary"
                key="console"
                onClick={() => {
                  window.location.href = '/';
                }}
              >
                Ir al inicio
              </Button>
            ]}
          />
        )}
        <ModalLoading
          open={solicitando}
          title="Enviando solicitud"
          subTitle="Procesando la información ingresada. Aguarde un momento."
          icon={<LoadingOutlined style={{ fontSize: 120 }} />}
        />
      </ResponsiveContainer>
    </div>
  );
}

export default FirmaView;
